import _ from 'lodash';
import React, { RefObject, useEffect, useState } from 'react';
import { FormControl } from 'react-bootstrap';
import styles from './UploadInput.module.css';
import BzmIcon from '../icons/BzmIcon';
import clsx from 'clsx';
import SimpleLoader from '../loaders/SimpleLoader';

interface UploadInputProps {
  /** File chooser placeholder is shown before file is selected. */
  placeholder: string;

  /** Description of the upload field */
  description?: string;

  /** When file is selected by file chooser */
  onFileSelected: (file: File | null) => void;

  /** Upload of selected file is in progress. */
  isInProgress: boolean;

  /** Supported file extensions file chooser will allow to select. */
  supportedExtensions: string;

  removeHandler?: (fileName: string) => void;

  /** To make htmlFor working if label is used. */
  uploadId?: string;

  /** Selected file in the input. */
  selectedFileName?: string;

  hasError?: boolean;

  disabled?: boolean;
}

/**
 * Enhanced inline file upload component.
 * @param props
 * @constructor
 */
const UploadInput = (props: UploadInputProps) => {
  const fileInputRef: RefObject<HTMLInputElement> = React.createRef();
  const [fileName, setFileName] = useState(props.selectedFileName);

  useEffect(() => {
    setFileName(props.selectedFileName);
  }, [props.selectedFileName]);

  const onChange = (event: any) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      props.onFileSelected(file);
      setFileName(file.name);
    } else {
      setFileName(null);
      props.onFileSelected(null);
    }
  };
  const uploading = (
    <div className={'d-inline-block text-muted'}>
      <SimpleLoader
        style={{ position: 'relative', bottom: 1 }}
        className={'d-inline-block mr-3'}
        loaderSize={14}
        showLoadingText={false}
      />
      Uploading ...
    </div>
  );
  return (
    <div className={clsx('form-control p-0 m-0', styles.formWrapper, props.hasError === true ? 'is-invalid' : '')}>
      <FormControl
        accept={props.supportedExtensions}
        id={props.uploadId}
        className={'d-none'}
        onChange={onChange}
        ref={fileInputRef}
        type="file"
      />
      <button
        type={'button'}
        disabled={props.isInProgress || props.disabled}
        className={clsx(
          styles.fileInput,
          props.isInProgress ? styles.inProgress : undefined,
          props.disabled ? styles.disabled : '',
        )}
        onClick={() => {
          if (fileInputRef.current) {
            fileInputRef.current.click();
          }
        }}
      >
        <BzmIcon className={clsx(styles.uploadIcon, 'mr-2')} variant={'icon-bzm-upload-cloud'} />
        <span className={'position-relative d-inline-block text-truncate'} style={{ maxWidth: '85%', bottom: '-2px' }}>
          {props.isInProgress ? (
            uploading
          ) : _.isEmpty(fileName) ? (
            <i className={'text-muted'}>{props.placeholder}</i>
          ) : (
            fileName
          )}
        </span>
        {!_.isEmpty(fileName) && (
          <BzmIcon
            title={'Remove'}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              if (props.removeHandler) {
                props.removeHandler(fileName);
              }
            }}
            className={clsx(styles.icon, 'float-right', 'hand-cursor')}
            variant={'icon-bzm-close-remove'}
          />
        )}
      </button>
      {!_.isNil(props.description) && <p className={'text-muted mt-2 mb-0'}>{props.description}</p>}
    </div>
  );
};

export default UploadInput;
